import React from 'react'

function MediaList({ onClick, children, cursorPointer }) {
  return <li
    className="media media--list"
    onClick={onClick}
    style={{ cursor: cursorPointer !== false ? 'pointer' : undefined }}
  >
    {children}
  </li>
}

export default MediaList
